import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { deviceRetain } from "@/api/dataAll/deviceRetain";
import * as echarts from "echarts";
import retainAllList from './components/retainAllList.vue';
export default {
  name: "deviceRetain",
  mixins: [tabulation],
  components: {
    retainAllList: retainAllList
  },
  data: function data() {
    return {
      more: true,
      tableData: [],
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      PrimitiveDy: [],
      intReq: [],
      screen: [],
      cellStylekeys: ["rem"]
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.kind = 1;
                _this.PrimitiveDy = [];

                _this.searchClickPoints(deviceRetain, 1);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      var res = {
        data: {
          register_sum: 0,
          data: {},
          avgData: {},
          other: {
            register_num: {}
          }
        }
      };
      qres.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
        res.data.other.register_num = _objectSpread(_objectSpread({}, res.data.other.register_num), i.other.register_num);
        res.data.register_sum = res.data.register_sum + Number(i.register_sum);

        for (var k in i.avgData) {
          var nums = i.retain_num[i.searchdate.starttime][k] == '/' ? 0 : Number(i.retain_num[i.searchdate.starttime][k]);
          res.data.avgData[k] = !res.data.avgData[k] ? nums : res.data.avgData[k] + nums;
        }
      });

      for (var i in res.data.avgData) {
        res.data.avgData[i] = (res.data.register_sum ? (res.data.avgData[i] / res.data.register_sum * 100).toFixed(2) : 0) + '%';
      }

      this.screen = [];
      this.series = [];
      this.dates = [];
      this.tableData = [];

      for (var k in res.data.data) {
        this.dates.push(k);
        var d = {
          date: k,
          register_num: res.data.other.register_num[k]
        };
        var length = Object.keys(res.data.data[k]).length;
        var o = {
          name: k,
          type: "line",
          data: [],
          smooth: true
        };
        var DynamicList = [];

        for (var j in res.data.data[k]) {
          d["rem" + j] = this.zhuan([res.data.data[k][j]])[0];
          o.data.push(d["rem" + j]);

          if (length > DynamicList.length) {
            var a = j == 2 ? this.$t('nextDayPrefix') || '次' : j;
            DynamicList.push({
              label: a + this.$t('rrSuffix') + j,
              prop: "rem" + j,
              tableText: j == 2 ? this.$t('rraSuffix') + j : this.$t('rrPrefix') + j,
              desc: j == 2 ? this.$t('nextDayDeviceRetention') : ""
            });
          }
        }

        if (!this.screen.length) {
          this.screen = DynamicList.map(function (item) {
            return item.prop;
          });
          this.PrimitiveDy = DynamicList;
        }

        this.screenControls();
        this.series.push(o);
        this.tableData.push(d);
      } // 总计数据处理


      var total = {
        date: this.$t('weightedAverageRetention'),
        register_num: res.data.register_sum
      };

      for (var _k in res.data.avgData) {
        total["rem" + _k] = this.zhuan([res.data.avgData[_k]])[0];
      }

      this.tableData.push(total);
      this.timeInterval();
      this.$nextTick(function () {
        _this2.getTableRight();
      });
      this.getechart();
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 50);
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("deviceRetainEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('deviceRetentionRate')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.label;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('newDeviceSlashDnd'),
        prop: "register_num"
      }].concat(_toConsumableArray(this.Dynamic));
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.Dynamic.forEach(function (item) {
        data.forEach(function (i) {
          i[item.prop] = i[item.prop] + "%";
        });
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    },
    gotoDetailList: function gotoDetailList(row, props) {
      console.log("row==", row, props);
      var date = row.date;
      var retainDay = props.replace('rem', '');
      var _this$searchData = this.searchData,
          game_id = _this$searchData.game_id,
          env_id = _this$searchData.env_id,
          special_product_id = _this$searchData.special_product_id;
      var query = {
        key: 'deviceRetain',
        register_date: date,
        retain_day: retainDay,
        game_id: game_id,
        env_id: env_id,
        special_product_id: special_product_id
      };
      this.$refs.retainAllList.init(query);
    }
  }
};